"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLinux = void 0;

var _getWindowObject2 = require("./get-window-object");

var isLinux = function isLinux() {
  var _getWindowObject$user, _getWindowObject;

  return /linux/i.test((_getWindowObject$user = (_getWindowObject = (0, _getWindowObject2.getWindowObject)('navigator')) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) !== null && _getWindowObject$user !== void 0 ? _getWindowObject$user : '');
};

exports.isLinux = isLinux;
//# sourceMappingURL=is-linux.js.map